import { render, staticRenderFns } from "./ChangePasswordComplete.vue?vue&type=template&id=487e9ecf&scoped=true&"
import script from "./ChangePasswordComplete.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordComplete.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordComplete.vue?vue&type=style&index=0&id=487e9ecf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487e9ecf",
  null
  
)

export default component.exports